// extracted by mini-css-extract-plugin
module.exports = {"message":"Comments_message__2azEx","cell":"Comments_cell__3fAfn","comment":"Comments_comment__GcHnx","row":"Comments_row__pvMQr","header":"Comments_header__2vq4S"};